import { useRef, useCallback } from "react";

/**
 * Latest-wins guard for overlapping requests. `startRequest()` returns
 * `isCurrent`, which turns false once a newer request starts; a stale
 * response must not touch state.
 */
export const useLatestRequest = () => {
  const latestIdRef = useRef(0);

  return useCallback(() => {
    latestIdRef.current += 1;
    const requestId = latestIdRef.current;
    return () => requestId === latestIdRef.current;
  }, []);
};
